import { render, staticRenderFns } from "./pay-result.vue?vue&type=template&id=690a10a0&scoped=true&"
import script from "./pay-result.vue?vue&type=script&lang=js&"
export * from "./pay-result.vue?vue&type=script&lang=js&"
import style0 from "./pay-result.vue?vue&type=style&index=0&id=690a10a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a10a0",
  null
  
)

export default component.exports